import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  isFetching: false,
  isFetched: false,
  error: null,
  regionHK: {},
  regionKLN: {},
  regionNT: {},
  regionETC: {},

  icsType: null,
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};
